import React from 'react'
import { H5 } from '@blueprintjs/core'
import {
  PrettyNumber,
  NewGridTable,
  GridTableStatusEnum,
  IGridTableColumn,
  IGridTableCell,
} from '@ui'
import { MAPPINGS, IMapping } from './MappingSelect'
import { pluralize } from '@utils'
import { Mapping } from './hooks/useImportMappings'
import css from './importFlow.module.scss'

interface IPreviewStepProps {
  parsedContent: any[]
  mappings: Mapping[]
}

export default function PreviewStep({ parsedContent, mappings }: IPreviewStepProps) {
  const columns: IGridTableColumn<any & { id: string }>[] = mappings
    .filter((d) => d.siq)
    .map((d) => ({
      label: (MAPPINGS.find((m) => 'value' in m && m.value === d.siq) as IMapping).label,
      Cell: ({ cell }) => {
        if (!cell) return null

        return <span style={{ whiteSpace: 'nowrap' }}>{cell.data[d.csv]}</span>
      },
      noWrap: true,
    }))

  const format = (items: any[]) => {
    return items.map((i) => ({
      data: { id: i['Employee ID'], ...i },
    }))
  }

  const formated: IGridTableCell<any & { id: string }>[] = format(parsedContent)

  return (
    <div>
      <H5>Preview</H5>
      <p>
        Your are about to import{' '}
        <strong>
          <PrettyNumber value={parsedContent.length} />
        </strong>{' '}
        {pluralize(parsedContent.length, 'record')}. Use this sample preview to check your data,
        then select import.
        <br />
        This will overwrite your employee data and you cannot cancel while importing.
      </p>
      <div className={css.table_wrapper}>
        <NewGridTable<any & { id: string }>
          sticky={false}
          minCellWidth={'auto'}
          status={GridTableStatusEnum.IDLE}
          columns={columns}
          data={formated.slice(0, 5)}
        />
      </div>
    </div>
  )
}
